import { FloppyDisk, Xmark } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';

type AgentDetailsHeaderActionsProps = {
  onCancel: () => void;
  onSaveAndPublish: () => void;
  /** Owner gets Save & Publish; shared editor gets Save. */
  isOwner?: boolean;
  isPublishing?: boolean;
  disabled?: boolean;
  className?: string;
};

export function AgentDetailsHeaderActions({
  onCancel,
  onSaveAndPublish,
  isOwner = true,
  isPublishing = false,
  disabled = false,
  className,
}: AgentDetailsHeaderActionsProps) {
  const { t } = useTranslation();
  const isActionDisabled = disabled || isPublishing;
  const cancelLabel = t('CANCEL') || 'Cancel';
  const saveLabel = isOwner ? t('SAVE_AND_PUBLISH') || 'Save & Publish' : t('SAVE') || 'Save';

  return (
    <div className={cn('flex shrink-0 items-center gap-2', className)}>
      <Button
        type="button"
        variant="outline"
        size="icon"
        disabled={isActionDisabled}
        onClick={onCancel}
        aria-label={cancelLabel}
        title={cancelLabel}
        className="size-10 shrink-0 !rounded-full border border-[#D9DBE9] bg-[linear-gradient(151deg,#FFFFFF_62.65%,#FBFBFE_83.011%)] text-[#170F49] shadow-none hover:bg-[linear-gradient(151deg,#FFFFFF_62.65%,#FBFBFE_83.011%)] hover:text-[#170F49] hover:opacity-90 sm:size-11 dark:border-border dark:bg-none dark:text-foreground [&_svg]:size-5"
      >
        <Xmark width={20} height={20} strokeWidth={1.75} />
      </Button>
      <Button
        type="button"
        size="icon"
        disabled={isActionDisabled}
        loading={isPublishing}
        onClick={() => onSaveAndPublish()}
        aria-label={saveLabel}
        title={saveLabel}
        className="size-10 shrink-0 !rounded-full border-0 text-white shadow-none hover:opacity-90 sm:size-11 [&_svg]:size-5"
      >
        {isPublishing ? null : <FloppyDisk width={20} height={20} strokeWidth={1.75} />}
      </Button>
    </div>
  );
}
